var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row-box"},[_vm._l((_vm.data),function(value,key){return _c('WrapperField',{key:value + key,attrs:{"data":_vm.createDataField({
        fieldName: key,
        fieldValue: value,
        fieldGroup: _vm.FieldGroup.CORRECT_TRANSLATION_DETAILS,
      })}})}),_vm._l((_vm.data.translatedDocument),function(value,key,index){return _c('WrapperField',{key:value + key + index,attrs:{"data":_vm.createDataField({
        fieldName: key,
        fieldValue: value,
        fieldGroup: _vm.FieldGroup.TRANSLATED_DOCUMENT,
      })}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }